import { render, staticRenderFns } from "./TocCode.vue?vue&type=template&id=ed0e94a8"
import script from "./TocCode.vue?vue&type=script&lang=js"
export * from "./TocCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports